import { IconButton, Tooltip } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { updateCommentarySection } from "../controller/update-commentary-section"
import { SECTION_DIALOG_TITLE_ID, ScheduleCommentarySectionDialog } from "./schedule-commentary-section-dialog"

export function ScheduleCommentaryEditSectionButton({ section }) {
    const { enqueueSnackbar } = useSnackbar()
    const openDialog = useDialog(
        <ScheduleCommentarySectionDialog heading="Edit section" okCaption="Save" section={section} />,
        { "aria-labelledby": SECTION_DIALOG_TITLE_ID }
    )

    return (
        <Tooltip title="Edit section">
            <IconButton
                size="small"
                color="primary"
                onClick={handleEdit}
                aria-label={`Edit section ${section.title}`}
                data-cy="schedule-commentary-edit-section"
            >
                <Iconify icon="mdi:pencil-outline" />
            </IconButton>
        </Tooltip>
    )

    async function handleEdit() {
        const edited = await openDialog()
        if (!edited) return
        try {
            await updateCommentarySection({ id: section.id, ...edited })
            enqueueSnackbar("Section saved", { variant: "success" })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to save section", { variant: "error" })
        }
    }
}
